/**
 * Строки календаря бизнеса и кнопок статусов (ТЗ §14.1, §14.2).
 *
 * Отдельный файл — см. пояснение в `dict.business.ts`: словарь кабинета разрезан по зонам
 * ответственности, чтобы параллельная работа не сходилась в одном файле строк.
 *
 * Тексты статусов и плиток перенесены из `pronto_booking.html` дословно (ключи `cNew`,
 * `cOk`, `cDone`, `cNoshow`, `stBookings`, `stLoad`…): расхождение формулировок
 * с визуальным эталоном — дефект, а не вариант.
 */

export const CALENDAR_STRINGS = {
  calTitle: ['Календарь', 'Kalendar'],
  calToday: ['Сегодня', 'Bugun'],
  calEmpty: ['На этот день записей нет.', 'Bu kunga yozuvlar yoʻq.'],
  calPrevDay: ['Назад', 'Orqaga'],
  calNextDay: ['Вперёд', 'Oldinga'],
  /* Подписи соседних дней. Считаются от «сегодня» В ПОЯСЕ ОРГАНИЗАЦИИ, а не по часам
     телефона: владельцу из другого пояса иначе показали бы «Вчера» над сегодняшним днём. */
  calYesterday: ['Вчера', 'Kecha'],
  calTomorrow: ['Завтра', 'Ertaga'],

  // ── Плитки. Пять штук, как в прототипе ──
  stBookings: ['Записей', 'Yozuvlar'],
  stLoad: ['Загрузка', 'Bandlik'],
  stNoshow: ['Неявки', 'Kelmaganlar'],
  stLate: ['Поздние отмены', 'Kech bekor qilish'],
  stFreed: ['Слотов освобождено', 'Boʻshagan slotlar'],
  /* Прочерк вместо числа, когда показателя НЕ СУЩЕСТВУЕТ: загрузки нет у выходного,
     доли неявок — у дня, который ещё не начался. Ноль здесь означал бы «работали
     и ничего не продали» и «неявок не было» — оба утверждения ложные (правило 7). */
  stNone: ['—', '—'],

  // ── Статусы записи ──
  cNew: ['Новая', 'Yangi'],
  cOk: ['Подтв.', 'Tasdiq'],
  cDone: ['Пришёл', 'Keldi'],
  cNoshow: ['Неявка', 'Kelmadi'],
  cCancelled: ['Отменена', 'Bekor qilingan'],
  cLateCancel: ['Поздняя отмена', 'Kech bekor qilingan'],

  // ── Кнопки под карточкой ──
  aCame: ['Пришёл', 'Keldi'],
  aCancel: ['Отменена', 'Bekor qilingan'],
  aNoShow: ['Неявка', 'Kelmadi'],
  aForgive: ['Снять отметку', 'Belgini olib tashlash'],

  // ── Подтверждения ──
  /* «Неявка» применяет шкалу санкций и может ограничить клиента на всей платформе
     (ТЗ §10.2). Такое действие не делается одним тапом без вопроса. */
  confirmNoShowT: ['Отметить неявку?', 'Kelmaganini belgilaymizmi?'],
  confirmNoShowB: [
    'Клиент получит предупреждение. Повторные неявки ведут к ограничению записи.',
    'Mijoz ogohlantirish oladi. Takroriy kelmasliklar yozuvni cheklashga olib keladi.',
  ],
  confirmCancelT: ['Отменить запись?', 'Yozuvni bekor qilamizmi?'],
  confirmCancelB: [
    'Клиент получит уведомление об отмене.',
    'Mijoz bekor qilish haqida xabar oladi.',
  ],
  confirmForgiveT: ['Снять отметку неявки?', 'Kelmaganlik belgisini olib tashlaymizmi?'],
  confirmForgiveB: [
    'Ограничения, наложенные этой неявкой, будут сняты.',
    'Bu kelmaganlik tufayli qoʻyilgan cheklovlar olib tashlanadi.',
  ],
  confirmYes: ['Да', 'Ha'],
  confirmNo: ['Отмена', 'Bekor qilish'],
} as const satisfies Record<string, readonly [string, string]>;
